import DropdownClickableItem from 'src/components/Dropdown/DropdownClickableItem';
import DropdownItem from '../../Dropdown/DropdownItem';
import { useAnalytics } from '../../AnalyticsProvider/AnalyticsProvider';

export type TCommentDropdownMenuProps = {
  isCommentAuthor: boolean;
  onDeleteButtonClick: () => void;
  commentId: string;
};

const CommentDropdownMenu: React.FC<TCommentDropdownMenuProps> = ({
  isCommentAuthor,
  onDeleteButtonClick,
  commentId,
}) => {
  const { sendEvent } = useAnalytics();

  const buttons = [
    {
      key: 'delete',
      text: 'Delete',
      onClick: onDeleteButtonClick,
      icon: <div className="before:content-bin" />,
      shouldDisplay: isCommentAuthor,
    },
    {
      key: 'report',
      text: 'Report',
      onClick: () => {},
      icon: <div className="before:content-flag" />,
      shouldDisplay: !isCommentAuthor,
    },
  ];

  return (
    <>
      {buttons
        .filter((button) => button.shouldDisplay)
        .map(({ onClick, text, icon, key }) => {
          const handleClick = () => {
            sendEvent('comment_options_dropdown_item_click', { item_name: key, comment_id: commentId });
            onClick();
          };

          return (
            <DropdownItem key={text}>
              <DropdownClickableItem rightAdornment={icon} onClick={handleClick}>
                {text}
              </DropdownClickableItem>
            </DropdownItem>
          );
        })}
    </>
  );
};
export default CommentDropdownMenu;
